import React, { useState, useRef, useEffect } from 'react';

const DropdownMenu = ({ 
  trigger, 
  children, 
  align = 'right',
  className = '',
  ...props 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const alignmentStyles = {
    right: { right: 0 },
    left: { left: 0 },
    center: { left: '50%', transform: 'translateX(-50%)' }
  };

  return (
    <div 
      ref={dropdownRef}
      style={{ position: 'relative', display: 'inline-block' }}
      className={className}
      {...props}
    >
      <div onClick={() => setIsOpen(!isOpen)}>
        {trigger}
      </div>
      
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            marginTop: 'var(--space-1)',
            minWidth: '200px',
            background: 'var(--bg-elevated)',
            border: '1px solid var(--color-gray-200)',
            borderRadius: 'var(--radius-lg)',
            boxShadow: 'var(--shadow-lg)',
            zIndex: 99999,
            overflow: 'hidden',
            paddingTop: '4px',
            paddingBottom: '4px',
            ...alignmentStyles[align]
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

const DropdownItem = ({ 
  children, 
  onClick, 
  icon,
  variant = 'default',
  className = '',
  ...props 
}) => {
  const variantStyles = {
    default: {
      color: 'var(--color-gray-700)',
      '&:hover': {
        background: 'var(--color-gray-50)',
        color: 'var(--color-gray-900)'
      }
    },
    danger: {
      color: 'var(--color-red-700)',
      '&:hover': {
        background: 'var(--color-red-50)',
        color: 'var(--color-red-900)'
      }
    },
    success: {
      color: 'var(--color-green-700)',
      '&:hover': {
        background: 'var(--color-green-50)',
        color: 'var(--color-green-900)'
      }
    }
  };

  return (
    <button
      onClick={onClick}
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-3)',
        padding: 'var(--space-3) var(--space-4)',
        border: 'none',
        background: 'transparent',
        fontSize: 'var(--font-size-sm)',
        fontWeight: 'var(--font-weight-medium)',
        textAlign: 'left',
        cursor: 'pointer',
        transition: 'all var(--transition-fast)',
        ...variantStyles[variant]
      }}
      className={className}
      {...props}
    >
      {icon && (
        <span style={{ fontSize: 'var(--font-size-base)' }}>
          {icon}
        </span>
      )}
      {children}
    </button>
  );
};

const DropdownSeparator = () => (
  <div style={{
    height: '1px',
    background: 'var(--color-gray-200)',
    margin: 'var(--space-1) 0'
  }} />
);

export { DropdownMenu, DropdownItem, DropdownSeparator };
export default DropdownMenu;
